// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__anfYC","left":"styles_left__3MFrK"};